"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8127],{

/***/ 75412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99653);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93391);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n				height: 20px;\n				background-position: -20px 0;\n			"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n				height: 21px;\n				background-position: -40px 0;\n			"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n				height: 23px;\n				background-position: 0px 0;\n			"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: block;\n	width: 18px;\n	margin-right: 10px;\n	background-image: url(",
        ");\n	background-size: 400px 400px;\n\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SearchIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].i.withConfig */ .ZP.i.withConfig({
    componentId: "sc-9a356e47-0"
})(_templateObject3(), (_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default()), function(props) {
    if (props.icon === "calendar") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
    }
    if (props.icon === "member") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
    }
    if (props.icon === "map") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2());
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (SearchIcon);


/***/ }),

/***/ 58127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XZ": function() { return /* reexport */ input_Checkbox; },
  "Y2": function() { return /* reexport */ input_NumberInput; },
  "Y8": function() { return /* reexport */ input_Radio; },
  "Mj": function() { return /* reexport */ input_SearchInput; },
  "oi": function() { return /* reexport */ input_TextInput; },
  "gx": function() { return /* reexport */ input_Textarea; }
});

// UNUSED EXPORTS: SearchInputBox

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./framework/ui/desktop/input/Checkbox.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n				background-color: #f6f7f2;\n\n				&:checked {\n					background-color: var(--emp-color);\n\n					&:after {\n						position: absolute;\n						left: 5px;\n						top: 1px;\n						width: 5px;\n						height: 9px;\n						border: solid #fff;\n						border-width: 0 3px 3px 0;\n						transform: rotate(45deg);\n						content: "";\n					}\n				}\n			'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	width: 20px;\n	height: 20px;\n	padding: 0;\n	border: none;\n	background-color: #fff;\n	cursor: pointer;\n	border: 1px solid var(--line-color);\n\n	&:checked {\n		border-color: var(--emp-color);\n		background-color: var(--emp-color);\n		&:after {\n			position: absolute;\n			left: 50%;\n			top: 5px;\n			width: 5px;\n			height: 9px;\n			border: solid #fff;\n			border-width: 0 2px 2px 0;\n			transform: rotate(45deg) translateX(-65%);\n			content: "";\n		}\n	}\n\n	&:disabled {\n		background-color: var(--disabled-color);\n		border-color: var(--line-color);\n		cursor: initial;\n\n		&:after {\n			border-color: var(--gray-color);\n			cursor: initial;\n		}\n		+ label {\n			cursor: initial;\n		}\n	}\n\n	',
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-3a869528-0"
})(_templateObject1(), function(props) {
    if (props.bg === "yellow") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject());
    }
});
var Checkbox = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var id = _param.id, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id"
    ]);
    return (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "checkbox",
        id: id
    }, props), {
        ref: ref
    }));
});
/* harmony default export */ var input_Checkbox = (Checkbox);

// EXTERNAL MODULE: ./public/P/images/ico/ico_spr.png
var ico_spr = __webpack_require__(99653);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
// EXTERNAL MODULE: ./framework/ui/desktop/icon/SearchIcon.tsx
var SearchIcon = __webpack_require__(75412);
;// CONCATENATED MODULE: ./framework/ui/desktop/input/SearchInput.tsx



function SearchInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 100%;\n"
    ]);
    SearchInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchInput_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	z-index: 1;\n	display: flex;\n	width: 100%;\n	height: 50px;\n	padding: 0 42px 0 10px;\n	border: 1px solid var(--line-color);\n	background-color: transparent;\n	overflow: hidden;\n	text-overflow: ellipsis;\n	cursor: ",
        ";\n"
    ]);
    SearchInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				width: 18px;\n				height: 20px;\n				background-position: -20px 0;\n			"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	right: 10px;\n	top: 50%;\n	z-index: 0;\n	margin-left: 0;\n	background-image: url(",
        ");\n	",
        "\n	transform: translateY(-50%);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var InputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3dea4c32-0"
})(SearchInput_templateObject());
var SearchInput_Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-3dea4c32-1"
})(SearchInput_templateObject1(), function(props) {
    return props.isReadonly ? "pointer" : "auto";
});
var Icon = (0,styled_components_browser_esm/* default */.ZP)(SearchIcon/* default */.Z).withConfig({
    componentId: "sc-3dea4c32-2"
})(_templateObject3(), (ico_spr_default()), function(props) {
    if (props.icon === "calendar") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
    }
});
var SearchInput = function(_param) /*#__PURE__*/ {
    var icon = _param.icon, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon"
    ]);
    return (0,jsx_runtime.jsxs)(InputWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput_Input, (0,_object_spread/* default */.Z)({
                type: "text"
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                icon: icon
            })
        ]
    });
};
/* harmony default export */ var input_SearchInput = (SearchInput);

;// CONCATENATED MODULE: ./framework/ui/desktop/input/TextInput.tsx




function TextInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: ",
        ";\n\n	&:read-only {\n		cursor: auto;\n	}\n"
    ]);
    TextInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TextInput_Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-244ac77e-0"
})(TextInput_templateObject(), function(props) {
    return props.width || "100%";
});
var TextInput = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var width = _param.width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "width"
    ]);
    return (0,jsx_runtime.jsx)(TextInput_Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "text",
        width: width
    }, props), {
        ref: ref
    }));
});
/* harmony default export */ var input_TextInput = (TextInput);

;// CONCATENATED MODULE: ./framework/ui/desktop/input/NumberInput.tsx



function NumberInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: ",
        ';\n	height: 45px;\n	border: 0 none;\n	border-top: 1px solid var(--line-color);\n	border-bottom: 1px solid var(--line-color);\n	font-size: var(--medium-size);\n	text-align: center;\n\n	&[type="text"]:focus {\n		border-color: var(--line-color);\n		outline: none;\n	}\n'
    ]);
    NumberInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var NumberInput_Number = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-6dbc1ac7-0"
})(NumberInput_templateObject(), function(props) {
    return props.width || "60px";
});
var NumberInput = function(_param) /*#__PURE__*/ {
    var width = _param.width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "width"
    ]);
    return (0,jsx_runtime.jsx)(NumberInput_Number, (0,_object_spread/* default */.Z)({
        type: "text",
        width: width
    }, props));
};
/* harmony default export */ var input_NumberInput = (NumberInput);

;// CONCATENATED MODULE: ./framework/ui/desktop/input/Radio.tsx



function Radio_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	line-height: 1;\n	align-items: center;\n	gap: 10px;\n\n	label {\n		display: flex;\n		align-items: center;\n		line-height: 1;\n		cursor: pointer;\n\n		&:has(input[type="radio"]:disabled) {\n			cursor: initial;\n		}\n	}\n\n	input[type="radio"] {\n		position: relative;\n		flex: 0 0 auto;\n		width: 18px;\n		height: 18px;\n		padding: 0;\n		border-radius: 100%;\n		cursor: pointer;\n\n		&:before {\n			position: absolute;\n			top: 50%;\n			left: 50%;\n			width: 0;\n			height: 0;\n			border-radius: 50%;\n			transform: translate(-50%, -50%);\n			content: "";\n			cursor: pointer;\n			transition: all 250ms ease;\n			box-sizing: border-box;\n		}\n\n		&:focus {\n			border: 1px solid var(--emp-color);\n			outline: none;\n		}\n\n		&:checked {\n			border: 1px solid var(--emp-color);\n			&:before {\n				width: 8px;\n				height: 8px;\n				background-color: var(--emp-color);\n			}\n		}\n\n		&:disabled {\n			background-color: var(--disabled-color);\n			cursor: initial;\n\n			&:before {\n				background-color: var(--gray-color);\n				cursor: initial;\n			}\n		}\n	}\n'
    ]);
    Radio_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ff4dde9-0"
})(Radio_templateObject());
var Radio = function(_param) /*#__PURE__*/ {
    var htmlFor = _param.htmlFor, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "htmlFor",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(Wrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                type: "radio"
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: htmlFor,
                children: children
            })
        ]
    });
};
/* harmony default export */ var input_Radio = (Radio);

;// CONCATENATED MODULE: ./framework/ui/desktop/input/Textarea.tsx



function Textarea_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: block;\n	width: ",
        ";\n	height: ",
        ";\n	line-height: 1.2;\n	padding: 15px;\n	border: 1px solid var(--line-color);\n	appearance: none;\n	box-shadow: none;\n	border-radius: 0;\n	box-sizing: border-box;\n	-webkit-text-size-adjust: none;\n	-webkit-border-radius: none;\n	-webkit-appearance: none;\n	color: var(--default-color);\n	resize: none;\n	white-space: pre-wrap;\n\n	&:disabled {\n		background-color: var(--disabled-color);\n	}\n	&:focus {\n		border-color: currentColor;\n		outline: 1px solid currentColor;\n	}\n"
    ]);
    Textarea_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TextareaSelect = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
    componentId: "sc-7d16ba5a-0"
})(Textarea_templateObject(), function(props) {
    return props.width ? props.width : "100%";
}, function(props) {
    return props.height ? props.height : "";
});
var Textarea = function(_param) /*#__PURE__*/ {
    var width = _param.width, height = _param.height, props = (0,_object_without_properties/* default */.Z)(_param, [
        "width",
        "height"
    ]);
    return (0,jsx_runtime.jsx)(TextareaSelect, (0,_object_spread/* default */.Z)({
        width: width,
        height: height
    }, props));
};
/* harmony default export */ var input_Textarea = (Textarea);

// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
;// CONCATENATED MODULE: ./framework/ui/desktop/input/SerachInputBox.tsx

function SerachInputBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	z-index: 5;\n	display: flex;\n	flex: 0 0 975px;\n	width: 100%;\n	border: 2px solid var(--emp-color);\n	box-sizing: border-box;\n	input {\n		flex: 0 0 860px;\n		width: 100%;\n		height: 56px;\n		line-height: 56px;\n		padding: 0 10px;\n		border: 0 none;\n		font-size: var(--medium-size);\n		font-family: "pr-font-medium";\n		color: var(--emp-color);\n		vertical-align: middle;\n		box-sizing: border-box;\n	}\n'
    ]);
    SerachInputBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SerachInputBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: 47px;\n	height: 56px;\n	background: #fff;\n\n	&::before {\n		display: block;\n		width: 8px;\n		height: 8px;\n		margin-top: 1px;\n		background: url(",
        ') -178px 0 / 300px 300px;\n		content: "";\n	}\n'
    ]);
    SerachInputBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SerachInputBox_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 63px;\n	height: 56px;\n	background-color: #fff;\n	&::before {\n		position: absolute;\n		top: 50%;\n		left: 50%;\n		display: block;\n		width: 24px;\n		height: 24px;\n		background: url(",
        ') -110px -26px / 400px 400px;\n		transform: translate(-50%, -50%);\n		content: "";\n	}\n	&:after {\n		position: absolute;\n		top: 50%;\n		left: 0;\n		display: block;\n		width: 1px;\n		height: 28px;\n		background-color: var(--line-color);\n		transform: translateY(-50%);\n		content: "";\n	}\n'
    ]);
    SerachInputBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SerachInputBox_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	position: absolute;\n	top: 56px;\n	left: -2px;\n	width: 975px;\n	min-height: 440px;\n	background: #fff;\n	border: 2px solid var(--emp-color);\n	box-sizing: border-box;\n\n	&:after {\n		position: absolute;\n		top: 0;\n		left: 341px;\n		display: block;\n		width: 1px;\n		height: 100%;\n		background-color: var(--line-color);\n		content: "";\n	}\n'
    ]);
    SerachInputBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	flex: 0 0 341px;\n	margin-top: 10px;\n	li {\n		flex: 0 0 35px;\n		padding: 0 10px;\n		&:hover {\n			background-color: #f3f3f3;\n		}\n		a {\n			display: flex;\n			align-items: center;\n			gap: 5px;\n			width: 100%;\n			height: 100%;\n		}\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex: 1 1 auto;\n	gap: 20px;\n	margin: 40px 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 285px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 15px 15px 10px 15px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	min-height: 48px;\n	max-height: 48px;\n	margin-bottom: 13px;\n	font-size: 16px;\n	font-family: "pr-font-medium";\n	color: var(--emp-color);\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 5px;\n	line-height: 1;\n	margin: -5px 0 26px 0;\n	color: var(--default-color);\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: block;\n	text-align: right;\n\n	> span {\n		line-height: 1;\n		font-size: var(--basic-size);\n		color: var(--red-color);\n		em {\n			font-size: 20px;\n		}\n	}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: -6px;\n	right: 0;\n	display: block;\n	width: 110px;\n	height: 38px;\n	line-height: 38px;\n	background: #eee;\n	font-size: var(--basic-size);\n	color: var(--emp-color);\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}






var SerachInputBox_Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-114fa8f8-0"
})(SerachInputBox_templateObject());
var AutoButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-114fa8f8-1"
})(SerachInputBox_templateObject1(), (ico_spr_default()));
var SerachInputBox_SearchIcon = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-114fa8f8-2"
})(SerachInputBox_templateObject2(), (ico_spr_default()));
var AutoSearchWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-114fa8f8-3"
})(SerachInputBox_templateObject3());
var AutoSearchList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-114fa8f8-4"
})(_templateObject4());
var CatalogList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-114fa8f8-5"
})(_templateObject5());
var CatalogListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-114fa8f8-6"
})(_templateObject6());
var CatalogListText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-114fa8f8-7"
})(_templateObject7());
var ProdTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-114fa8f8-8"
})(_templateObject8());
var ProdDate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-114fa8f8-9"
})(_templateObject9());
var ProdPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-114fa8f8-10"
})(_templateObject10());
var ProdButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-114fa8f8-11"
})(_templateObject11());
var SearchInputBox = function() {
    var ref = useState(false), show = ref[0], setShow = ref[1];
    return /*#__PURE__*/ _jsxs(SerachInputBox_Wrap, {
        children: [
            /*#__PURE__*/ _jsx("input", {}),
            /*#__PURE__*/ _jsx(AutoButton, {
                onClick: function() {
                    return setShow(!show);
                },
                children: /*#__PURE__*/ _jsx("span", {
                    children: "자동완성 여닫기"
                })
            }),
            /*#__PURE__*/ _jsx(SerachInputBox_SearchIcon, {
                children: /*#__PURE__*/ _jsx("span", {
                    children: "검색하기"
                })
            }),
            show && /*#__PURE__*/ _jsxs(AutoSearchWrap, {
                children: [
                    /*#__PURE__*/ _jsxs(AutoSearchList, {
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsxs("a", {
                                    href: "#",
                                    children: [
                                        /*#__PURE__*/ _jsx(BlueText, {
                                            children: "일본"
                                        }),
                                        "교토 자유여행"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsxs("a", {
                                    href: "#",
                                    children: [
                                        /*#__PURE__*/ _jsx(BlueText, {
                                            children: "일본"
                                        }),
                                        "동경 자유여행"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsxs("a", {
                                    href: "#",
                                    children: [
                                        /*#__PURE__*/ _jsx(BlueText, {
                                            children: "일본"
                                        }),
                                        "삿포로 자유여행"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsxs("a", {
                                    href: "#",
                                    children: [
                                        /*#__PURE__*/ _jsx(BlueText, {
                                            children: "일본"
                                        }),
                                        "오사카 자유여행"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsxs("a", {
                                    href: "#",
                                    children: [
                                        /*#__PURE__*/ _jsx(BlueText, {
                                            children: "일본"
                                        }),
                                        "자유여행"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(CatalogList, {
                        children: [
                            /*#__PURE__*/ _jsxs(CatalogListItem, {
                                children: [
                                    /*#__PURE__*/ _jsx(Noimage, {
                                        width: "285px",
                                        height: "195px",
                                        src: "https://dimgcdn.ybtour.co.kr/TN/19/19913e6676b513ad88b539597724d5ad.tn.410x280.jpg",
                                        alt: "상품 이미지"
                                    }),
                                    /*#__PURE__*/ _jsxs(CatalogListText, {
                                        children: [
                                            /*#__PURE__*/ _jsx(ProdTitle, {
                                                children: "시드니 + 포트스테판 6일 #시드니동물원 #하버디너크루즈"
                                            }),
                                            /*#__PURE__*/ _jsxs(ProdDate, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "출발기간"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "2024.03.01 ~ 2024.03.06"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(ProdPrice, {
                                                children: /*#__PURE__*/ _jsx(ProdButton, {
                                                    children: "상품보기"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(CatalogListItem, {
                                children: [
                                    /*#__PURE__*/ _jsx(Noimage, {
                                        width: "285px",
                                        height: "195px",
                                        src: "https://dimgcdn.ybtour.co.kr/TN/19/19913e6676b513ad88b539597724d5ad.tn.410x280.jpg",
                                        alt: "상품 이미지"
                                    }),
                                    /*#__PURE__*/ _jsxs(CatalogListText, {
                                        children: [
                                            /*#__PURE__*/ _jsx(ProdTitle, {
                                                children: "시드니 + 포트스테판 6일 #시드니동물원 #하버디너크루즈"
                                            }),
                                            /*#__PURE__*/ _jsxs(ProdDate, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "출발기간"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "2024.03.01 ~ 2024.03.06"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(ProdPrice, {
                                                children: /*#__PURE__*/ _jsx(ProdButton, {
                                                    children: "상품보기"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SerachInputBox = ((/* unused pure expression or super */ null && (SearchInputBox)));

;// CONCATENATED MODULE: ./framework/ui/desktop/input/index.ts









/***/ })

}]);